const StringUtil = {
  GetFirstLetters: (str: string, count = 2) => {
    return str.split(' ')
      .map(word => word[0])
      .slice(0, count)
      .join('');
  },
}

export default StringUtil;